import type { ReactNode } from 'react';

import styles from './discount-banner.module.scss';

/** Highlighted callout used on the discount detail (Limited Time Offer / Offer Expired /
 *  Flexible Discount). Shared by the summary card + tier table (and ticket 07's actions);
 *  the caller supplies the per-variant icon + surface `tone` (Figma 4083-219055). */
type Props = {
  icon: ReactNode;
  title: string;
  description: string;
  tone: 'lime' | 'muted';
};

export function DiscountBanner({ icon, title, description, tone }: Props) {
  return (
    <div className={[styles.banner, styles[tone]].join(' ')}>
      <span className={styles.icon} aria-hidden>
        {icon}
      </span>
      <div className={styles.text}>
        <p className={styles.title}>{title}</p>
        <p className={styles.desc}>{description}</p>
      </div>
    </div>
  );
}
